const ScaleArrowIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="5"
    viewBox="0 0 245 5"
    fill="none"
    preserveAspectRatio="none"
  >
    <path
      d="M0 2.28125L3.94888 4.56136L3.94908 0.00147731L0 2.28125ZM245 2.29186L241.051 0.0117455L241.051 4.57163L245 2.29186ZM3.55408 2.2814L3.55406 2.6763L241.446 2.6866L241.446 2.29171L241.446 1.89681L3.5541 1.88651L3.55408 2.2814Z"
      fill="#7C7C7C"
    />
  </svg>
)

export default ScaleArrowIcon
